import { matchPath } from 'react-router-dom';
import PATHS from '../../../routes/routes.const';
import { UserRole } from '../../users/roles';
import { ChatState } from '../contexts/chat/hooks/useChats/reducer/chatListReducer.types';
import { Message } from '../contexts/chatSocket/reducer/chatSocketReducer.types';
import { ChatMessage, ChatType, MessageType, VideoCallChatMessage } from '../types/chat.types';
import {
  CHAT_BOTTOM_DEFAULT_POSITION,
  CHAT_BOTTOM_POSITION_IN_ORDER_EDIT_PAGE,
  CHAT_BOTTOM_POSITION_IN_ORDER_PAGE_MOBILE,
} from './chat.constants';

const getChatPositionInOrdersPage = (smallWidth: boolean) => {
  if (smallWidth) {
    return CHAT_BOTTOM_POSITION_IN_ORDER_PAGE_MOBILE;
  }

  return CHAT_BOTTOM_POSITION_IN_ORDER_EDIT_PAGE;
};

type ChatPosition = {
  pathname: string;
  smallWidth: boolean;
};
export const getChatPosition = ({ pathname, smallWidth }: ChatPosition): number => {
  const isInOrderEditPage = !!matchPath(pathname, PATHS.main.orders.editForm.path);
  const isInOrderSuggestedPage = !!matchPath(pathname, PATHS.main.orders.suggestion.path);
  if (isInOrderEditPage || isInOrderSuggestedPage) {
    return getChatPositionInOrdersPage(smallWidth);
  }
  return CHAT_BOTTOM_DEFAULT_POSITION;
};

export const removeWebsocketMessageByTempId = (messages: Message[], tempId: string): Message[] =>
  messages.filter((wsMessage) => wsMessage.tempId !== tempId);

export const removeWebsocketMessagesByChat = (messages: Message[], chatId: string): Message[] =>
  messages.filter((wsMessage) => wsMessage.chatId !== chatId);

export const removeWebsocketMessageByMessageId = (
  messages: Message[],
  messageId: string,
): Message[] => messages.filter((wsMessage) => wsMessage.id !== messageId);

export const invertChatRole = (
  isPrivate: boolean,
  isStore: boolean,
  userRole: UserRole,
): UserRole => {
  if (isPrivate) {
    return isStore ? 'ADMIN_MARCA' : 'ADMIN_LOJA';
  }

  return userRole;
};

export const isChatStateProps = (props: any): props is ChatState => {
  return props?.wasRemoved !== undefined;
};

export const isVideoCallChatMessageType = (props: ChatMessage): props is VideoCallChatMessage => {
  return props.type === MessageType.VIDEO_CALL;
};

export const isGroupChat = (type: ChatType): boolean => type === ChatType.GROUP;

export const isTopicChat = (type: ChatType): boolean => type === ChatType.TOPIC;

export const isPrivateChat = (type: ChatType): boolean => type === ChatType.PRIVATE;
